/* eslint import/no-webpack-loader-syntax: off */

import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { Theme } from '../../config/theme';
import { IS_MESSAGING_ENABLED } from '../../utils/Api';
import CompanyLogo from '../CompanyLogo';
import UserMenu from '../UserMenu';

import MobileNav from '../MobileNav';
import NotificationsMenu from '../NotificationsMenu';
import SettingsMenu from '../SettingsMenu';

class DashboardHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobNavOpen: false,
    };

    this.logoutHandler = this.props.logoutHandler.bind(this);
    this.toggleMobNav = this.toggleMobNav.bind(this);
  }

  toggleMobNav() {
    this.setState({
      mobNavOpen: !this.state.mobNavOpen,
    });
  }

  render() {
    const {
      user: { active_subscription: ACTIVE_SUBSCRIPTION },
      messaging: { unreadCount },
    } = this.props;

    return (
      <div className={css(styles.container) + ' DashboardHeader'}>
        <div className={css(styles.header_container)}>
          <div className={css(styles.header)}>
            <div className={css(styles.logo_container)}>
              <CompanyLogo link="/find" styles={styles.company_logo} />
            </div>
            <div className={css(styles.links)}>
              {ACTIVE_SUBSCRIPTION ? (
                <NavLink
                  to="/find"
                  className={css(styles.nav_item)}
                  activeClassName={css(styles.nav_item_active)}
                >
                  Find a dog
                </NavLink>
              ) : null}
              {ACTIVE_SUBSCRIPTION ? (
                <NavLink
                  to="/shares"
                  className={css(styles.nav_item)}
                  activeClassName={css(styles.nav_item_active)}
                >
                  My Dog Shares
                </NavLink>
              ) : null}
              {ACTIVE_SUBSCRIPTION ? (
                <NavLink
                  to="/favourites"
                  className={css(styles.nav_item)}
                  activeClassName={css(styles.nav_item_active)}
                >
                  My Favourites
                </NavLink>
              ) : null}
              {ACTIVE_SUBSCRIPTION && IS_MESSAGING_ENABLED ? (
                <NavLink
                  to="/inbox"
                  className={css(styles.nav_item, styles.nav_item_with_badge)}
                  activeClassName={css(styles.nav_item_active)}
                >
                  Messages
                  {unreadCount > 0 && (
                    <span className={css(styles.unread_badge)}>
                      {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                  )}
                </NavLink>
              ) : null}
            </div>
            <div className={css(styles.buttons)}>
              <UserMenu user={this.props.user} />
              {ACTIVE_SUBSCRIPTION ? <NotificationsMenu {...this.props} /> : null}
              <SettingsMenu logoutHandler={this.logoutHandler} />
              <div
                className={css(styles.mob_hamburger_wrapper)}
                onClick={this.toggleMobNav}
                role="button"
                tabIndex={0}
              >
                <div className={css(styles.mob_hamburger)} />
                {unreadCount > 0 && <span className={css(styles.mob_hamburger_indicator)} />}
              </div>
            </div>
          </div>
        </div>
        <MobileNav
          toggle={this.toggleMobNav}
          isOpen={this.state.mobNavOpen}
          unreadCount={unreadCount}
        />
      </div>
    );
  }
}

DashboardHeader.propTypes = {
  user: PropTypes.object.isRequired,
  logoutHandler: PropTypes.func.isRequired,
  messaging: PropTypes.object,
};

DashboardHeader.defaultProps = {
  messaging: { unreadCount: 0 },
};

const styles = StyleSheet.create({
  mob_hamburger_wrapper: {
    position: 'relative',
    display: 'none',
    width: 30,
    height: 21,
    marginLeft: 5,
    cursor: 'pointer',

    [Theme.mobile_query]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  mob_hamburger: {
    position: 'relative',
    height: 3,
    width: 30,
    borderRadius: 3,
    backgroundColor: '#000',

    ':before': {
      position: 'absolute',
      top: -9,
      height: 3,
      width: 30,
      borderRadius: 3,
      backgroundColor: '#000',
      content: '""',
    },

    ':after': {
      position: 'absolute',
      top: 9,
      height: 3,
      width: 30,
      borderRadius: 3,
      backgroundColor: '#000',
      content: '""',
    },
  },
  mob_hamburger_indicator: {
    position: 'absolute',
    top: -3,
    right: -3,
    height: 12,
    width: 12,
    borderRadius: 6,
    backgroundColor: Theme.secondary,
    border: `2px solid ${Theme.white}`,
    display: 'none',

    [Theme.mobile_query]: {
      display: 'block',
    },
  },
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: '100',
    display: 'flex',
    width: '100vw',
    height: Theme.navigation.height,
    backgroundColor: Theme.white,
  },
  header_container: {
    position: 'relative',
    display: 'flex',
    margin: '0 auto',
    width: Theme.container_width,
    alignItems: 'center',

    [Theme.mobile_query]: {
      paddingRight: 10,
    },
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
  },
  logo_container: {
    width: 180,

    [Theme.mobile_query]: {
      width: 0,
    },
  },
  company_logo: {
    position: 'absolute',
    top: 10,
    left: 0,
  },
  links: {
    flex: 2,
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',

    [Theme.mobile_query]: {
      display: 'none',
    },
  },
  buttons: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  nav_item: {
    position: 'relative',
    textTransform: 'uppercase',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    fontSize: Theme.font_size_secondary,
    letterSpacing: 1,
    color: Theme.dark_grey,
    transition: 'all 160ms ease-in-out',
    marginLeft: 20,
    marginRight: 20,
    ':hover': {
      color: Theme.primary,
    },
  },
  nav_item_disabled: {
    color: Theme.grey,
    cursor: 'not-allowed',
    ':hover': {
      color: Theme.grey,
    },
  },
  nav_item_active: {
    color: Theme.primary,
  },
  nav_item_with_badge: {
    position: 'relative',
  },
  unread_badge: {
    position: 'absolute',
    top: -10,
    right: -20,
    minWidth: 20,
    height: 20,
    padding: '0 5px',
    backgroundColor: Theme.secondary,
    color: Theme.white,
    borderRadius: 10,
    fontSize: 12,
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: Theme.font_family_primary,
  },
  coming_soon: {
    position: 'absolute',
    marginLeft: -10,
    maxWidth: 61,
    maxHeight: 23,
  },
});

const mapStateToProps = state => ({
  messaging: state.messaging,
});

export default connect(mapStateToProps)(DashboardHeader);



// WEBPACK FOOTER //
// ./src/components/DashboardHeader/index.js